<template>
  <div>
    <v-container fluid>
      <!-- TOP PART -->
      <v-row>
        <v-col cols="4">
          <h4>{{ $t("ration.prepareRelation") }}</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" class="text-center">
          <p>Step 2 of 3 | {{ $t("ration.ingredientSelection") }}</p>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="4" class="text-right">
          <v-btn outlined color="primary" class="mr-2" @click="back">
            Back
          </v-btn>
          <v-btn color="primary" @click="isRationSuggestion = true">
            Next
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-4"></v-divider>

      <!-- INGREDIENTS SELECTIONS HERE -->

      <v-row class="pb-3">
        <v-col cols="12">
          <h3>
            {{ $t("ration.ingredientSelection") }}
            <span class="green--text" style="font-size: 14px"
              >({{ selectedGroups }}) {{ $t("ration.group") }}
              <span v-if="selectedGroups > 1">(s)</span>
              {{ $t("ration.selected") }}</span
            >
          </h3>
        </v-col>
      </v-row>
      <v-card
        elevation="0"
        class="my-2"
        v-for="item in animalgroups"
        :key="item.groupId"
      >
        <v-card-text>
          <div class="green2 my-2 px-4">
            <v-row>
              <v-col cols="4" class="">
                <p class="d-flex align-center justify-start mb-0">
                  <v-icon @click="expandToggleFirst(item)">{{
                    isExpandedFirst[item.id]
                      ? "mdi-chevron-up"
                      : "mdi-chevron-down"
                  }}</v-icon>
                  {{ item.groupName }} {{ totalAnimalCount(item) }}
                  <!-- <v-checkbox
                    :hide-details="true"
                    class="ml-3"
                    v-model="applyToAllCheckBox"
                    @click="applyToAllSubGroups(item)"
                  ></v-checkbox> -->
                  <!-- v-if="item?.subGroup?.length > 1" -->
                  <!-- <span>Apply to all Sub-Groups</span> -->
                </p>
              </v-col>
              <v-col cols="8" class="d-flex align-center justify-end no-wrap">
                <p class="mb-0">
                  <v-btn
                    x-small
                    class="mr-2"
                    style="background: white"
                    color="grey"
                    outlined
                    >{{ item?.subGroup?.length }} Sub Group</v-btn
                  >
                  <span
                    @click="getSubGroupAnimalDetails(item.subGroup, subgroup)"
                    class="fs-14 text-decoration-underline green--text divider"
                    v-for="subgroup in item.subGroup"
                    :key="item.groupId + subgroup.id"
                    >{{ subgroup?.subGroupName }}</span
                  >
                  <v-icon
                    color="error"
                    class="pl-2"
                    @click="removeAnimalGroup(item)"
                    >mdi-trash-can</v-icon
                  >
                </p>
              </v-col>
            </v-row>
          </div>

          <span
            :style="isExpandedFirst[item.id] ? 'display:block' : 'display:none'"
          >
            <v-alert
              class="mt-10"
              color="#FAF5DA"
              style="border: 1px solid #ffb443"
            >
              {{ $t("ration.ingredientNote1") }} {{ item.groupName
              }}{{ $t("ration.ingredientNote2") }}
            </v-alert>
            <ingredient-selection
              :updateTab="updateSubGroupTab"
              :groupDetails="item"
              @selectedSubGroupTabChange="getSelectedGroup"
            ></ingredient-selection>
          </span>
        </v-card-text>
      </v-card>
    </v-container>
    <sub-group-animal-details
      v-if="showSubGroupAnimalDetails"
      :dialogI="showSubGroupAnimalDetails"
      @closeDialog="showSubGroupAnimalDetails = false"
      :subGroups="subGroups"
      :rationAnimalGeneratedSubGroupId="rationAnimalGeneratedSubGroupId"
    >
    </sub-group-animal-details>

    <ration-suggestion
      v-if="isRationSuggestion"
      :dialogI="isRationSuggestion"
      @closeDialog="isRationSuggestion = false"
      @rationPriority="setRationPriority"
    ></ration-suggestion>

    <confirm-box
      v-if="deleteAnimalGroup"
      :dialog="deleteAnimalGroup"
      title="Warning"
      message="Are you sure you want to delete this record?"
      confirmBtnText="Delete"
      :confirmData="itemToDelete"
      @confirm:action="deleteRationConfirmed"
    />
  </div>
</template>
<script>
import SubGroupAnimalDetails from "@/views/feed_management/ration_library/DialogBox/SubGroupAnimalDetails";
import IngredientSelectionComponent from "../components/_IngredientGroupSelection";
import { getAllRationByRationIds } from "@/graphql/Feed.gql";
import { mapGetters } from "vuex";
import ConfirmBox from "@/components/ConfirmBox.vue";
import { removeRationAnimalGroups } from "@/graphql/Feed.gql";
import RationSuggestion from "../DialogBox/RationSuggestion.vue";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  components: {
    "sub-group-animal-details": SubGroupAnimalDetails,
    "ingredient-selection": IngredientSelectionComponent,
    "confirm-box": ConfirmBox,
    "ration-suggestion": RationSuggestion,
  },
  apollo: {
    getAllRationByRationIds: {
      query: getAllRationByRationIds,
      update: data => data,
      fetchPolicy: "no-cache",
      variables() {
        return {
          ids: this.rationId,
        };
      },
      result({ data }) {
        let rationAnimalGroups = data.getAllRationByRationIds.reduce(
          (rationAnimalGroup, ration) => {
            const rationAnimalGroupStack = ration.rationAnimalGroups.map(
              group => {
                return { ...group, rationId: +ration.id };
              }
            );
            return [...rationAnimalGroup, ...rationAnimalGroupStack];
          },
          []
        );
        this.items = rationAnimalGroups;
        this.selectedGroups = rationAnimalGroups?.length;
        this.animalgroups = rationAnimalGroups;
      },
    },
  },
  watch: {
    items() {
      this.updateGroupDetailState();
    },
  },
  data() {
    return {
      updateSubGroupTab: 0,
      applyToAllCheckBox: false,
      isExpandedFirst: false,
      isExpandedSecond: false,
      showSubGroupAnimalDetails: false,
      animalgroups: [],
      subGroupAnimals: [],
      rationAnimalGeneratedSubGroupId: null,
      subGroups: [],
      selectedGroups: 0,
      groupDetails: {},
      items: [],
      noOfGroups: 0,
      deleteAnimalGroup: false,
      itemToDelete: null,
      selectedSubGroup: null,
      isSubGroupIngredientReadyForNextStep: false,
      rationId: null,
      isRationSuggestion: false,
      rationPriority: null,
    };
  },
  computed: {
    ...mapGetters([
      "groupDetailForRationSuggestion",
      "rationIdForIngredientList",
    ]),
  },
  mounted() {
    this.rationId = this.$route.query.rationId?.map(r => {
      return +r;
    });
    // Use the value of 'id'
  },
  methods: {
    totalAnimalCount(items) {
      let totalCount = 0;
      items?.subGroup.forEach(item => {
        const subGroupName = item.subGroupName;
        const regex = /\d+/; // This regular expression matches one or more digits
        const match = subGroupName.match(regex);
        totalCount += parseInt(match[0], 10) ?? 0; // Convert the matched string to an integer
      });
      return totalCount;
    },
    updateGroupDetailState() {
      if (!this.groupDetailForRationSuggestion?.length) {
        this.$store.commit("setGroupDetailForRationSuggestion", this.items);
      }
    },
    expandToggleFirst(item) {
      this.groupDetails = item;
      this.isExpandedFirst = !this.isExpandedFirst;
      this.selectedSubGroup = item.subGroup[0].id;
    },
    expandToggleSecond() {
      this.isExpandedSecond = !this.isExpandedSecond;
    },

    async setRationPriority(data) {
      this.rationPriority = data;
      await this.next();
    },
    async next() {
      const preparedData = await this.prepareDataForRationSuggestion();
      if (!this.isSubGroupIngredientReadyForNextStep) {
        this.$notify({
          title: "Error!",
          text: "Please select ingredients first!!",
          type: "error",
        });
        return;
      }
      this.isRationSuggestion = true;

      await this.$store.commit("setRationSuggestionInput", preparedData);
      this.$router.push({
        name: "RationSuggestion",
        query: {
          rationId: this.rationId,
          rationPriority: this.rationPriority,
        },
      });
    },
    back() {
      this.$router.go(-1);
    },
    getSubGroupAnimalDetails(item, subGroup) {
      this.subGroups = item;
      this.rationAnimalGeneratedSubGroupId = Number(subGroup.id);
      this.showSubGroupAnimalDetails = true;
    },
    applyToAllSubGroups(item) {
      if (this.applyToAllCheckBox) {
        if (!this.selectedSubGroup || !this.isSubGroupChecked(item)) {
          this.$notify({
            title: "Error!",
            text: "Please select sub-group!!",
            type: "error",
          });
          return;
        }
        item.selectedSubGroup = this.selectedSubGroup;
        this.$store.commit("applyToAllSubGroups", item);
      } else {
        this.$store.commit("uncheckIngredientsForAll", item);
        this.updateSubGroupTab++;
      }

      this.applyToAllCheckBox = !this.applyToAllCheckBox;
    },

    isSubGroupChecked(item) {
      const groupIndex = this.groupDetailForRationSuggestion.findIndex(
        obj => obj.groupId == item.groupId
      );

      const subGroupIndex = this.groupDetailForRationSuggestion[
        groupIndex
      ].subGroup.findIndex(subgroup => subgroup.id == this.selectedSubGroup);

      if (
        !(
          "ingredients" in
          this.groupDetailForRationSuggestion[groupIndex]?.subGroup[
            subGroupIndex
          ]
        ) ||
        !this.groupDetailForRationSuggestion[groupIndex]?.subGroup[
          subGroupIndex
        ]?.ingredients?.length
      ) {
        return false;
      }
      return true;
    },

    prepareDataForRationSuggestion() {
      let result = this.groupDetailForRationSuggestion.map(group => {
        let subGroupIngredients = group.subGroup.map(subgroup => {
          if ("ingredients" in subgroup && subgroup?.ingredients?.length) {
            this.isSubGroupIngredientReadyForNextStep = true;
            let ingredients = subgroup.ingredients.map(ingredient => {
              return {
                ingredientID: ingredient.ingredientID,
                quantity: +ingredient.quantity,
              };
            });
            return {
              subGroupId: Number(subgroup.id),
              ingredients,
            };
          }
        });

        const filteredSubGroupIngredients = subGroupIngredients.filter(
          value => value !== undefined
        );
        return {
          groupId: group.groupId,
          rationId: +group.rationId,
          subGroupIngredients: filteredSubGroupIngredients,
        };
      });

      const finalResult = result.filter(d => d.subGroupIngredients.length > 0);

      return {
        animalGroupsForIngredient: finalResult,
        // rationId: Number(this.rationId),
      };
    },

    removeAnimalGroup(item) {
      this.itemToDelete = item;
      this.deleteAnimalGroup = true;
    },
    async deleteRationConfirmed(action, item) {
      this.startLoading();
      if (action) {
        this.$apollo
          .mutate({
            mutation: removeRationAnimalGroups,
            variables: {
              rationAnimalGroupId: parseInt(item.id),
            },
          })
          .then(async ({ data }) => {
            if (data.removeRationAnimalGroups.success) {
              this.$notify({
                title: "Success!",
                text: "Animal Group deleted successfully!",
                type: "success",
              });
              this.stopLoading();
              this.$router.go(-1);
            }
          })
          .catch(e => {
            console.log("arc", e);
            this.stopLoading();
          });
      }
      this.itemToDelete = null;
      this.deleteAnimalGroup = false;
    },

    getSelectedGroup(value) {
      this.selectedSubGroup = value;
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border-active {
  border: 1px solid green !important;
}

:deep.subHeader .v-data-table-header {
  background-color: #fde9c7 !important;
}

.divider {
  border-right: 1px solid #6a7784;
  padding: 0 14px;
  cursor: pointer;
}

.fs-14 {
  font-size: 14px;
}

.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
</style>
